import { Skeleton, Stack } from "@mui/material";

import React from "react";
import JobDetails from "./JobDetails";
import JobResult from "./JobResult";
import JobLogs from "./JobLogs";
import JobProgess from "./JobProgess";

const JobInformation = ({
  data,
  isLoading,
  onResultClick,
  resultData,
}: // getResultData,
{
  data: any;
  isLoading?: boolean;
  onResultClick?: any;
  resultData?: any;
  // getResultFn
}) => {
  const { templateInfo, job } = data ?? {};

  // const onJobResultClickFn = () => {
  //   // getResultData();
  // };
  return isLoading ? (
    <Stack gap={1}>
      <Skeleton height={200} />
      <Skeleton height={100} />
    </Stack>
  ) : (
    <Stack sx={{ mb: 5 }} rowGap={3}>
      {job && (
        <JobDetails
          name={job?.name}
          jobId={job?.id}
          description={job?.description}
          dataSource={job?.dataSource?.dataSourceDescriptor}
          dataDestination={job?.dataDestination?.dataSourceDescriptor}
          jobTimeOut={job?.config?.jobTimeOut}
          taskTimeOut={job?.config?.taskTimeOut}
          templateId={job?.templateId}
          appId={templateInfo?.appTag}
          dataSourceData={job?.dataSource}
          dataDestinationData={job?.dataDestination}
          partitionerId={templateInfo?.partitioner}
          assemblerId={templateInfo?.assembler}
          appParams={job?.params?.app}
          partitionerParameter={job?.params?.partitioner}
          assemblerParameter={job?.params?.assembler}
        />
      )}

      {job?.state === "JOB_STATE_COMPLETE" && (
        <JobResult
          chunks={job?.numChunks}
          duration={job?.duration}
          cost={job?.paymentAmount}
          id={job?.id}
          onClickFn={onResultClick}
          resultData={resultData}
        />
      )}
      {job?.state === "JOB_STATE_FAILED" && (
        <JobLogs errorMessage={job?.errorMessage} />
      )}
      <JobProgess state={job?.state} stateTimestamps={job?.stateTimestamps} />
    </Stack>
  );
};

export default JobInformation;
